import React from 'react';
import { connect } from 'react-redux';

import { Parser } from 'html-to-react';

import Typography from '@mui/material/Typography';

import { getHomeContent } from 'reducers/selectors';

const Home = ({ homeContent }) => (
    <div className="home-content">
        <h2 style={{ textAlign: 'center' }}>Great you found the place!</h2>
        <Typography
            sx={{ color: '#000000' }}
            variant="subtitle1"
            id="tableTitle"
            component="div"
            className="mb-4"
        >
            {Parser().parse(homeContent)}
        </Typography>
    </div>
);

export default connect(state => {
    return {
        homeContent: getHomeContent(state),
    };
}, null)(Home);
